/**
 * Ryzup shop PDP — bundle + flavor picker, AJAX add to cart (badge only).
 */
(function () {
  const SUCCESS_MS = 1800;

  function getRoutes() {
    return window.routes || {};
  }

  function ajaxCartUrl(basePath) {
    const routes = getRoutes();
    const root = (routes.root_url || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    let path = basePath || routes.cart_url || '/cart';

    if (!path.startsWith('http') && root && root !== '/' && !path.startsWith(root)) {
      path = `${root}${path.startsWith('/') ? path : `/${path}`}`;
    }

    if (path.endsWith('.js') || path.endsWith('.json')) return path;
    return `${path}.js`;
  }

  function cartAddUrl() {
    const routes = getRoutes();
    return ajaxCartUrl(routes.cart_add_url || '/cart/add');
  }

  function cartFetchUrl() {
    const routes = getRoutes();
    return ajaxCartUrl(routes.cart_url || '/cart');
  }

  function getButtonLabel(btn) {
    return btn?.querySelector('.btn__label');
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;

    const spinner = btn.querySelector('.btn__spinner');
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (spinner) spinner.hidden = !loading;
  }

  function showButtonSuccess(btn, addedLabel) {
    const labelEl = getButtonLabel(btn);
    if (!labelEl) return;

    if (!labelEl.dataset.originalLabel) {
      labelEl.dataset.originalLabel = labelEl.textContent;
    }

    labelEl.textContent = addedLabel;

    window.setTimeout(() => {
      labelEl.textContent = labelEl.dataset.originalLabel;
    }, SUCCESS_MS);
  }

  function initShopPdp() {
    const root = document.querySelector('[data-ryzup-shop-pdp]');
    if (!root) return;

    const addedLabel = root.dataset.addedLabel || 'Ajouté au panier ✓';

    let config;
    try {
      config = JSON.parse(root.querySelector('[data-ryzup-catalog]')?.textContent || '{}');
    } catch (error) {
      console.error('[ryzup-shop-pdp] Invalid catalog JSON', error);
      return;
    }

    const form = root.querySelector('form[data-ryzup-product-form]');
    const variantInput = form?.querySelector('[name="id"]');
    const sellingPlanInput = form?.querySelector('[name="selling_plan"]');
    const errorEl = root.querySelector('[data-ryzup-cart-error]');
    const titleEl = root.querySelector('[data-ryzup-product-title]');
    const gallery = window.RyzupShopGallery?.createGallery(root);

    let selectedBundle = config.defaultBundle || 'pack-1';
    let selectedFlavor = config.defaultFlavor || 'coffee';

    function normalizeFlavor(value) {
      const v = (value || '').toLowerCase();
      if (v.includes('caf') || v.includes('coffee') || v.includes('kaff')) return 'coffee';
      if (v.includes('matcha')) return 'matcha';
      if (v.includes('chocol') || v.includes('cioccol') || v.includes('schok') || v.includes('cacao')) {
        return 'chocolate';
      }
      return v;
    }

    function flavorFromQuery() {
      const params = new URLSearchParams(window.location.search);
      const raw = params.get('saveur') || params.get('flavor') || '';
      const map = {
        cafe: 'coffee',
        coffee: 'coffee',
        matcha: 'matcha',
        chocolat: 'chocolate',
        chocolate: 'chocolate',
      };
      return map[raw.toLowerCase()] || null;
    }

    function findVariant(bundleKey, flavorKey) {
      const bundle = config.bundles?.[bundleKey];
      if (!bundle) return null;
      return (
        (bundle.variants || []).find((v) => normalizeFlavor(v.flavor) === flavorKey) ||
        bundle.variants?.[0]
      );
    }

    function showError(message) {
      if (!errorEl) {
        console.error('[ryzup-shop-pdp]', message);
        return;
      }
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
    }

    function clearError() {
      errorEl?.classList.add('hidden');
      if (errorEl) errorEl.textContent = '';
    }

    function updateCartBadge(itemCount) {
      const link = document.getElementById('cart-icon-bubble');
      if (!link) return;

      let bubble = link.querySelector('.cart-count-bubble');
      if (!itemCount || itemCount <= 0) {
        bubble?.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        link.appendChild(bubble);
      }

      let countEl = bubble.querySelector('[aria-hidden="true"]');
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.setAttribute('aria-hidden', 'true');
        bubble.appendChild(countEl);
      }
      countEl.textContent = itemCount < 100 ? String(itemCount) : '';

      let srEl = bubble.querySelector('.visually-hidden');
      if (!srEl) {
        srEl = document.createElement('span');
        srEl.className = 'visually-hidden';
        bubble.appendChild(srEl);
      }
      srEl.textContent = `${itemCount} article${itemCount > 1 ? 's' : ''}`;
    }

    async function fetchCart() {
      const res = await fetch(cartFetchUrl(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error(`Cart fetch failed (${res.status})`);
      return res.json();
    }

    async function refreshCartBadge() {
      const cart = await fetchCart();
      updateCartBadge(cart.item_count);
      return cart;
    }

    async function addToCart(variantId, sellingPlanId) {
      const item = {
        id: Number.parseInt(String(variantId), 10),
        quantity: 1,
      };
      if (sellingPlanId) {
        item.selling_plan = Number.parseInt(String(sellingPlanId), 10);
      }

      const res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] }),
      });

      let data;
      try {
        data = await res.json();
      } catch {
        throw new Error('Réponse panier invalide');
      }

      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || `Erreur panier (${res.status})`);
      }

      const cart = await refreshCartBadge();

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ryzup-shop-pdp',
          productVariantId: String(variantId),
          cartData: cart || data,
        });
      }

      return cart || data;
    }

    function currentSellingPlanId(variant) {
      if (variant?.selling_plan_id) return variant.selling_plan_id;
      if (!sellingPlanInput || sellingPlanInput.disabled) return null;
      return sellingPlanInput.value || null;
    }

    function gallerySlidesForFlavor(flavorKey) {
      return config.galleries?.[flavorKey] || config.galleries?.coffee || [];
    }

    function updateGallery() {
      gallery?.setSlides(gallerySlidesForFlavor(selectedFlavor));
    }

    function updateUI() {
      const variant = findVariant(selectedBundle, selectedFlavor);
      if (!variant) {
        showError('Produit indisponible pour cette sélection.');
        return;
      }

      clearError();

      if (variantInput) variantInput.value = variant.id;
      if (sellingPlanInput) {
        const planId = variant.selling_plan_id;
        if (planId) {
          sellingPlanInput.value = planId;
          sellingPlanInput.removeAttribute('disabled');
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.setAttribute('disabled', 'disabled');
        }
      }

      if (titleEl && variant.title) titleEl.textContent = variant.title;

      updateGallery();
      root.dataset.flavor = selectedFlavor;
      root.querySelectorAll('[data-bundle-id]').forEach((el) => {
        const input = el.matches('input') ? el : el.querySelector('input');
        const isSelected = (input?.value || el.dataset.bundleId) === selectedBundle;
        el.classList.toggle('is-selected', isSelected);
        if (input) input.checked = isSelected;
      });
      root.querySelectorAll('[data-shop-flavor]').forEach((btn) => {
        const flavor = btn.getAttribute('data-shop-flavor');
        const active = flavor === selectedFlavor;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    async function runAddToCartAction(btn, addFn) {
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

      clearError();
      setButtonLoading(btn, true);

      try {
        await addFn();
        showButtonSuccess(btn, addedLabel);
      } catch (error) {
        showError(error.message || 'Impossible d’ajouter au panier.');
        console.error('[ryzup-shop-pdp]', error);
      } finally {
        setButtonLoading(btn, false);
      }
    }

    async function handleAddToCart(triggerEl) {
      const variant = findVariant(selectedBundle, selectedFlavor);
      if (!variant?.id) {
        showError('Sélection invalide — rechargez la page.');
        return;
      }

      await runAddToCartAction(triggerEl, () =>
        addToCart(variant.id, currentSellingPlanId(variant)),
      );
    }

    root.addEventListener('change', (event) => {
      const input = event.target.closest('.bundle-picker input[type="radio"]');
      if (input) {
        selectedBundle = input.value;
        updateUI();
      }
    });

    root.addEventListener('click', (event) => {
      const flavorBtn = event.target.closest('[data-shop-flavor]');
      if (flavorBtn) {
        selectedFlavor = flavorBtn.getAttribute('data-shop-flavor');
        updateUI();
      }
    });

    document.addEventListener('click', (event) => {
      const discoveryBtn = event.target.closest('[data-ryzup-discovery-add]');
      if (!discoveryBtn || !config.discovery?.variant_id) return;
      event.preventDefault();

      runAddToCartAction(discoveryBtn, () => addToCart(config.discovery.variant_id));
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      handleAddToCart(form.querySelector('[data-ryzup-add-to-cart]') || form.querySelector('[type="submit"]'));
    });

    const queryFlavor = flavorFromQuery();
    if (queryFlavor && config.flavors?.includes(queryFlavor)) {
      selectedFlavor = queryFlavor;
    }

    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopPdp, { once: true });
  } else {
    initShopPdp();
  }
})();
